// Root route. Wraps every page in QueryClientProvider + AuthGate. Shell-vs-no-
// Shell is decided structurally by the route tree: anything under _authed.tsx
// gets the Shell layout; / and /login* render their own chrome.

import { AuthGate } from '@/components/AuthGate';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet, createRootRoute } from '@tanstack/react-router';

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <QueryClientProvider client={qc}>
      <AuthGate>
        <Outlet />
      </AuthGate>
    </QueryClientProvider>
  );
}
